function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 .071h17.924v17.701H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .157)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.96.071c4.946-.001 8.96 3.96 8.964 8.844.004 4.89-4.017 8.861-8.969 8.857C4.011 17.768 0 13.802 0 8.92 0 4.035 4.014.072 8.96.07zM7.147 4.422c-.157-.182-.156-.18-.357-.164a6.18 6.18 0 0 0-2.98 1.06.911.911 0 0 0-.28.308 13.56 13.56 0 0 0-1.006 2.376c-.4 1.243-.644 2.513-.657 3.82 0 .069.021.156.066.203.967 1.017 2.178 1.495 3.572 1.562.056.003.136.002.165-.031.254-.287.5-.582.762-.892-.824-.25-1.541-.606-2.088-1.236 3.08 1.706 6.156 1.707 9.236 0-.546.632-1.266.985-2.082 1.237.232.278.453.532.661.796.084.107.174.136.305.128 1.36-.081 2.546-.545 3.495-1.534.053-.056.1-.15.096-.224-.038-.552-.06-1.108-.142-1.655a13.984 13.984 0 0 0-1.566-4.637.497.497 0 0 0-.15-.167c-.926-.634-1.944-1.022-3.072-1.117-.152-.012-.265.021-.343.17 1.014.3 1.982.688 2.83 1.337-3.103-1.391-6.201-1.39-9.304.002.85-.648 1.82-1.04 2.839-1.342zm-.383 3.933c.707.017 1.26.573 1.256 1.261a1.245 1.245 0 0 1-1.26 1.232A1.24 1.24 0 0 1 5.54 9.58c.012-.68.572-1.24 1.224-1.226zm4.438 0c.652.01 1.197.594 1.181 1.267a1.235 1.235 0 0 1-1.262 1.224 1.242 1.242 0 0 1-1.215-1.254 1.26 1.26 0 0 1 1.296-1.237z",
  fill: "#FFF",
  mask: "url(#b)"
}));

function SvgDiscordWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordWhite);
export default __webpack_public_path__ + "static/media/discord-white.910ca702.svg";
export { ForwardRef as ReactComponent };